import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.testimonials';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);
      const slider = query.querySelector('.splide');

      const sliderContainer = query.querySelector('.splide__list');
      data.forEach((item) => {
        const itemEl = document.createElement('div');
        itemEl.classList.add('splide__slide');
        itemEl.innerHTML = /* html */ `
          <div class="testimonials__item">
            <div class="testimonials__item__rating">
              <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/star.svg" alt="Rating" width="24" height="24">
              <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/star.svg" alt="Rating" width="24" height="24">
              <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/star.svg" alt="Rating" width="24" height="24">
              <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/star.svg" alt="Rating" width="24" height="24">
              <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/star.svg" alt="Rating" width="24" height="24">
            </div>
            <div class="testimonials__item__text">
              <p>${item.text}</p>
            </div>
            <div class="testimonials__item__person">
              <div class="testimonials__item__image">
                <img src="${item.image}" alt="${item.name}" width="50" height="50">
              </div>
              <div class="testimonials__item__info">
                <span class="testimonials__item__name">${item.name}</span>
                <span class="testimonials__item__company">${item.company}</span>
              </div>
            </div>
          </div>
        `;
        sliderContainer.appendChild(itemEl);
      });

      new Splide(slider, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        gap: '60px',
        pagination: false,
        breakpoints: {
          1300: {
            perPage: 3,
            gap: '40px',
          },
          1024: {
            perPage: 2,
            gap: '30px',
          },
          768: {
            perPage: 1,
            gap: '0px',
          },
        },
      }).mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
